module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý tỉnh thành"
    }
  }, [_c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'create-city'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm\n      mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.cityTable,
    attrs: {
      "table-name": _vm.cityTable,
      "data-source": "cities",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": "",
            "row-class-name": _vm.tableRowClassName
          }
        }, [_vm._v("\n          >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.cityTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.cityTable].current_page - 1) * _vm.dataPaginations[_vm.cityTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Vùng Miền",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_c('span', [_vm._v(_vm._s(scope.row.region_name))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tên"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', {
                staticClass: "text-center"
              }, [_vm._v(_vm._s(scope.row.name) + " (" + _vm._s(scope.row.short_name) + ")")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Mã Bưu Chính"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', {
                staticClass: "text-center"
              }, [_c('span', {
                staticClass: "shipment-code-display"
              }, [_vm._v(_vm._s(scope.row.code))])])]
            }
          }], null, true)
        }), _vm._v(" "), _vm._l((_vm.listCarriers), function(carrier, index) {
          return _c('el-table-column', {
            key: index,
            attrs: {
              "label": carrier.name
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function(scope) {
                return [_c('p', {
                  staticClass: "text-center"
                }, [_c('span', {
                  staticClass: "shipment-code-display text-normal-case"
                }, [_vm._v(_vm._s(scope.row[carrier.key]))])])]
              }
            }], null, true)
          })
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Lấy hàng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.allow) ? _c('i', {
                staticClass: "fa fa-check-square-o"
              }) : _c('i', {
                staticClass: "fa fa-square-o"
              })]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [(!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Chi tiết"
                }
              }, [_c('a', {
                staticClass: "text-blue padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.detailCity(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-search"
              })])]) : _vm._e(), _vm._v(" "), (!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('router-link', {
                staticClass: "text-orange padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'edit-city',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o",
                attrs: {
                  "aria-hidden": "true"
                }
              })])], 1) : _vm._e(), _vm._v(" "), (!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deleteCity(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Khôi phục"
                }
              }, [_c('a', {
                staticClass: "text-blue padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.restore(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-refresh",
                attrs: {
                  "aria-hidden": "true"
                }
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 2)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn vùng miền"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.region_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "region_id", $$v)
      },
      expression: "filters.region_id"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Chọn vùng miền",
      "value": -1
    }
  }), _vm._v(" "), _vm._l((_vm.regions), function(region) {
    return _c('el-option', {
      key: region.id,
      attrs: {
        "label": region.name,
        "value": region.id
      }
    })
  })], 2)], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Chi tiết tỉnh thành: ' + this.city.name,
      "visible": _vm.detailModal
    },
    on: {
      "update:visible": function($event) {
        _vm.detailModal = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "margin-sm-top margin-sm-bottom"
  }, [_vm._v("Vùng miền: "), _c('span', {
    staticClass: "text-blue text-bold"
  }, [_vm._v(_vm._s(_vm.city.name))])]), _vm._v(" "), _c('p', {
    staticClass: "margin-sm-top margin-sm-bottom"
  }, [_vm._v("Code: "), _c('span', {
    staticClass: "shipment-code-display"
  }, [_vm._v(_vm._s(_vm.city.code))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', {
    staticClass: "margin-sm-top margin-sm-bottom"
  }, [_vm._v("Mã giao hàng nhanh: "), _c('span', {
    staticClass: "shipment-code-display"
  }, [_vm._v(_vm._s(_vm.city.code_ghn))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', {
    staticClass: "margin-sm-top margin-sm-bottom"
  }, [_vm._v("Mã VTP: "), _c('span', {
    staticClass: "shipment-code-display"
  }, [_vm._v(_vm._s(_vm.city.code_vtp))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', {
    staticClass: "margin-sm-top margin-sm-bottom"
  }, [_vm._v("Mã Ninja Van: "), _c('span', {
    staticClass: "shipment-code-display"
  }, [_vm._v(_vm._s(_vm.city.code_njv))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', {
    staticClass: "margin-sm-top margin-sm-bottom"
  }, [_vm._v("Mã Kerry: "), _c('span', {
    staticClass: "shipment-code-display"
  }, [_vm._v(_vm._s(_vm.city.code_kerry))])])])], 1), _vm._v(" "), (_vm.city.regions) ? _c('el-table', {
    attrs: {
      "data": _vm.city.regions.data
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "name",
      "label": "Tên"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-8be49306"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/city/City.vue
// module id = 726
// module chunks = 1